/**
 * Форматирует количество секунд в читаемый формат времени.
 * Примеры:
 * - 3661 → "1 ч. 1 мин."
 * - 3600 → "1 ч."
 * - 120 → "2 мин."
 * - 59 → "59 сек."
 *
 * @param {number} seconds - Количество секунд.
 * @returns {string} Отформатированная строка времени.
 */
export const formatLeftTime = (seconds) => {
  const totalSeconds = Math.floor(seconds);

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  const parts = [];

  if (hours > 0) {
    parts.push(`${hours} ч.`);
  }

  if (minutes > 0) {
    parts.push(`${minutes} мин.`);
  }

  if (secs >= 0 && minutes === 0) {
    parts.push(`${secs} сек.`);
  }

  return parts.join(" ");
};
